var _desc, _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudydenWhiteWordmarkTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 854,
    height: 607,
    viewBox: "223 315 854 607",
    role: "img",
    "aria-label": "STUDYDEN Studyden White Wordmark Transparent",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "STUDYDEN Studyden White Wordmark Transparent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "STUDYDEN logo reconstructed from supplied Bear One.png. Pure vector Bezier paths and gradients; lettering outlined. No embedded raster artwork or external fonts.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bear-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 287,746 C 276,732 262,707 258,695 C 253,683 260,674 269,665 C 291,643 301,624 307,601 C 314,578 315,553 330,519 C 343,486 365,463 397,444 C 426,425 444,416 469,409 C 488,403 511,400 532,395 C 568,399 605,405 634,407 C 665,404 690,398 717,391 C 759,373 812,370 865,374 C 868,357 878,347 893,345 C 910,347 921,357 927,370 C 945,373 961,378 979,385 L 982,400 C 1006,410 1028,421 1046,431 C 1037,447 1025,462 1013,472 C 983,476 956,482 931,488 C 894,498 865,516 845,540 C 839,561 846,591 859,614 C 875,643 898,668 912,697 C 945,708 965,723 966,746 L 848,746 C 837,735 824,727 811,722 C 790,716 772,707 755,697 C 751,704 749,711 748,718 C 761,724 769,735 770,746 L 682,746 C 664,714 671,673 690,629 C 675,627 660,627 644,627 C 630,658 607,687 587,711 C 614,718 631,729 632,746 L 505,746 C 494,732 502,714 500,693 C 500,673 492,651 479,636 C 441,645 389,677 344,711 C 363,718 377,731 378,746 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rear",
    gradientUnits: "userSpaceOnUse",
    x1: 491,
    y1: 437,
    x2: 312,
    y2: 744
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1543F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7531EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A622EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rear-wash",
    gradientUnits: "userSpaceOnUse",
    x1: 368,
    y1: 473,
    x2: 281,
    y2: 711
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A45AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A124E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rear-gloss",
    gradientUnits: "userSpaceOnUse",
    x1: 380,
    y1: 456,
    x2: 326,
    y2: 615
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD78ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "toe",
    gradientUnits: "userSpaceOnUse",
    x1: 346,
    y1: 712,
    x2: 379,
    y2: 755
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6835DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5725DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "saddle",
    gradientUnits: "userSpaceOnUse",
    x1: 562,
    y1: 397,
    x2: 636,
    y2: 536
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4636EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7454FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8521E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3530D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "far-leg",
    gradientUnits: "userSpaceOnUse",
    x1: 685,
    y1: 610,
    x2: 751,
    y2: 759
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302FE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9829E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "far-front",
    gradientUnits: "userSpaceOnUse",
    x1: 839,
    y1: 549,
    x2: 933,
    y2: 753
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DCCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2BABEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "far-front-shadow",
    gradientUnits: "userSpaceOnUse",
    x1: 809,
    y1: 624,
    x2: 876,
    y2: 748
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thigh",
    gradientUnits: "userSpaceOnUse",
    x1: 451,
    y1: 416,
    x2: 570,
    y2: 746
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00A8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thigh-rim",
    gradientUnits: "userSpaceOnUse",
    x1: 537,
    y1: 405,
    x2: 640,
    y2: 713
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00BBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thigh-gloss",
    gradientUnits: "userSpaceOnUse",
    x1: 476,
    y1: 446,
    x2: 551,
    y2: 578
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41BCDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "thigh-gloss-rim",
    gradientUnits: "userSpaceOnUse",
    x1: 525,
    y1: 410,
    x2: 627,
    y2: 548
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03EFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53D4E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hind-shadow",
    gradientUnits: "userSpaceOnUse",
    x1: 478,
    y1: 635,
    x2: 573,
    y2: 748
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoulder",
    gradientUnits: "userSpaceOnUse",
    x1: 778,
    y1: 394,
    x2: 854,
    y2: 722
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0083F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoulder-left",
    gradientUnits: "userSpaceOnUse",
    x1: 680,
    y1: 423,
    x2: 775,
    y2: 699
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#36B3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "head",
    gradientUnits: "userSpaceOnUse",
    x1: 840,
    y1: 390,
    x2: 1039,
    y2: 444
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B8CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "back-gloss",
    gradientUnits: "userSpaceOnUse",
    x1: 704,
    y1: 390,
    x2: 780,
    y2: 525
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97E9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70CDE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neck-gloss",
    gradientUnits: "userSpaceOnUse",
    x1: 785,
    y1: 518,
    x2: 958,
    y2: 444
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#137CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chest-gloss",
    gradientUnits: "userSpaceOnUse",
    x1: 876,
    y1: 470,
    x2: 793,
    y2: 616
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BA6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chest-shadow",
    gradientUnits: "userSpaceOnUse",
    x1: 845,
    y1: 533,
    x2: 796,
    y2: 712
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1837EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ear",
    gradientUnits: "userSpaceOnUse",
    x1: 883,
    y1: 347,
    x2: 906,
    y2: 378
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0797B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#29CEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ABC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ear-gloss",
    gradientUnits: "userSpaceOnUse",
    x1: 882,
    y1: 351,
    x2: 910,
    y2: 370
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27BED6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-0",
    gradientUnits: "userSpaceOnUse",
    x1: 446.562,
    y1: 484.498,
    x2: 317.162,
    y2: 753.545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#312ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4B32E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7234EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9332E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#982CE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-1",
    gradientUnits: "userSpaceOnUse",
    x1: 673.336,
    y1: 543.008,
    x2: 388.412,
    y2: 483.619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#124CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0E36E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0A26E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0623D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0023CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-2",
    gradientUnits: "userSpaceOnUse",
    x1: 664.117,
    y1: 423.182,
    x2: 614.969,
    y2: 454.806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7B6AEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6F5AEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#654DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5D2AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E00CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-3",
    gradientUnits: "userSpaceOnUse",
    x1: 634.239,
    y1: 430.126,
    x2: 621.191,
    y2: 452.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5653EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5F3DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#692EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7728E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8723E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-4",
    gradientUnits: "userSpaceOnUse",
    x1: 328.604,
    y1: 618.566,
    x2: 257.305,
    y2: 680.263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A257EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9D49ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9B3FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9736E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#932DE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-5",
    gradientUnits: "userSpaceOnUse",
    x1: 385.537,
    y1: 547.176,
    x2: 319.652,
    y2: 546.044
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#94A4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#999CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A497F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B195F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB8FF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-6",
    gradientUnits: "userSpaceOnUse",
    x1: 361.432,
    y1: 722.352,
    x2: 335.01,
    y2: 743.722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5B37E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6138E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6937E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7234E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B31E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-7",
    gradientUnits: "userSpaceOnUse",
    x1: 716.242,
    y1: 641.233,
    x2: 706.105,
    y2: 742.219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4131E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5230E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6430E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#792EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922CE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-8",
    gradientUnits: "userSpaceOnUse",
    x1: 892.361,
    y1: 753.782,
    x2: 850.609,
    y2: 554.933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1887F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#30A9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4DBDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-9",
    gradientUnits: "userSpaceOnUse",
    x1: 846.92,
    y1: 746.918,
    x2: 826.372,
    y2: 613.027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0161F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0175F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#018AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#029FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03B5E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-10",
    gradientUnits: "userSpaceOnUse",
    x1: 541.139,
    y1: 528.13,
    x2: 515.859,
    y2: 735.222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02BCD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#02A1DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0186EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#006CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-11",
    gradientUnits: "userSpaceOnUse",
    x1: 637.037,
    y1: 508.442,
    x2: 604.914,
    y2: 736.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07CDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0DBDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0DA4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0484F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005FF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-12",
    gradientUnits: "userSpaceOnUse",
    x1: 518.827,
    y1: 572.307,
    x2: 498.122,
    y2: 407.482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ABFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#30C4D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#14CCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#02DCBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-13",
    gradientUnits: "userSpaceOnUse",
    x1: 593.411,
    y1: 405.947,
    x2: 593.501,
    y2: 549.017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00F4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#13E8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#35DDD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4FD9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63D7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-14",
    gradientUnits: "userSpaceOnUse",
    x1: 530.579,
    y1: 663.996,
    x2: 513.234,
    y2: 741.176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0061F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0059FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0051FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#004CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-15",
    gradientUnits: "userSpaceOnUse",
    x1: 891.384,
    y1: 363.921,
    x2: 891.322,
    y2: 368.273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02B6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#01B8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#01BAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#02BAD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02B5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-16",
    gradientUnits: "userSpaceOnUse",
    x1: 906.506,
    y1: 365.019,
    x2: 885.119,
    y2: 351.749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33C5E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49CAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#68D4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#89E1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEDEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-18",
    gradientUnits: "userSpaceOnUse",
    x1: 820.491,
    y1: 692.31,
    x2: 734.18,
    y2: 518.936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003DFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0050FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0064F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#017EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#029AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-19",
    gradientUnits: "userSpaceOnUse",
    x1: 765.802,
    y1: 715.266,
    x2: 652.839,
    y2: 482.015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0041FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0D65FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2189F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3EB3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD9DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-20",
    gradientUnits: "userSpaceOnUse",
    x1: 912.489,
    y1: 526.998,
    x2: 819.738,
    y2: 378.127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0056FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0174F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0394E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#04B0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04C8CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-21",
    gradientUnits: "userSpaceOnUse",
    x1: 750.657,
    y1: 483.394,
    x2: 683.847,
    y2: 412.381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7FCAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7ED2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7FDCDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8BE6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97F0D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-22",
    gradientUnits: "userSpaceOnUse",
    x1: 994.619,
    y1: 475.949,
    x2: 852.237,
    y2: 413.251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0776F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A91ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#34A8EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52BEEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-23",
    gradientUnits: "userSpaceOnUse",
    x1: 978.947,
    y1: 512.488,
    x2: 813.49,
    y2: 485.654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0060F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#107AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2793F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#45A4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FB1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fit-24",
    gradientUnits: "userSpaceOnUse",
    x1: 811.187,
    y1: 594.367,
    x2: 807.276,
    y2: 592.613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1623D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1225D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1227D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#152ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1529DA"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bear",
    clipPath: "url(#bear-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "silhouette",
    d: "M 287,746 C 276,732 262,707 258,695 C 253,683 260,674 269,665 C 291,643 301,624 307,601 C 314,578 315,553 330,519 C 343,486 365,463 397,444 C 426,425 444,416 469,409 C 488,403 511,400 532,395 C 568,399 605,405 634,407 C 665,404 690,398 717,391 C 759,373 812,370 865,374 C 868,357 878,347 893,345 C 910,347 921,357 927,370 C 945,373 961,378 979,385 L 982,400 C 1006,410 1028,421 1046,431 C 1037,447 1025,462 1013,472 C 983,476 956,482 931,488 C 894,498 865,516 845,540 C 839,561 846,591 859,614 C 875,643 898,668 912,697 C 945,708 965,723 966,746 L 848,746 C 837,735 824,727 811,722 C 790,716 772,707 755,697 C 751,704 749,711 748,718 C 761,724 769,735 770,746 L 682,746 C 664,714 671,673 690,629 C 675,627 660,627 644,627 C 630,658 607,687 587,711 C 614,718 631,729 632,746 L 505,746 C 494,732 502,714 500,693 C 500,673 492,651 479,636 C 441,645 389,677 344,711 C 363,718 377,731 378,746 Z",
    fill: "url(#fit-0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "back-blue",
    d: "M 391,451 C 436,417 478,403 532,395 C 568,399 608,405 634,407 C 681,402 710,392 742,383 L 703,479 L 654,627 L 479,636 C 420,597 373,541 386,480 Z",
    fill: "url(#fit-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "saddle-panel",
    d: "M 532,397 C 576,400 633,404 679,426 C 657,450 650,482 656,529 C 643,496 630,456 594,423 C 580,410 559,402 532,397 Z",
    fill: "url(#fit-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "back-saddle-rim",
    d: "M 534,397 C 554,398 581,401 601,409 C 627,421 645,438 658,458 L 654,482 C 636,446 610,407 534,397 Z",
    fill: "url(#fit-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rear-sweep",
    d: "M 399,445 C 358,469 335,505 321,550 C 306,597 311,628 271,669 C 262,678 258,684 261,695 C 277,682 300,662 323,631 C 344,603 349,573 360,541 C 370,515 379,487 399,445 Z",
    fill: "url(#fit-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rear-highlight",
    d: "M 396,450 C 365,472 339,506 326,542 C 316,568 311,590 320,606 C 328,622 342,617 353,606 C 369,589 378,568 381,545 C 386,512 379,486 396,450 Z",
    fill: "url(#fit-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rear-paw",
    d: "M 344,711 C 334,723 329,734 328,746 L 378,746 C 377,731 363,718 344,711 Z",
    fill: "url(#fit-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "far-leg",
    d: "M 696,613 C 682,646 660,698 674,731 L 682,746 L 770,746 C 768,734 760,725 748,718 C 750,708 754,696 764,684 Z",
    fill: "url(#fit-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "far-front-leg",
    d: "M 847,527 C 837,551 844,586 859,614 C 875,643 898,668 912,697 C 945,708 965,723 966,746 L 848,746 C 837,735 824,727 809,721 C 791,681 794,620 807,583 Z",
    fill: "url(#fit-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "far-front-leg-shade",
    d: "M 810,586 C 800,620 826,646 852,668 C 882,693 895,722 897,746 L 848,746 C 836,734 824,727 809,721 C 790,681 791,628 810,586 Z",
    fill: "url(#fit-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hind-leg",
    d: "M 453,417 C 481,402 512,401 537,407 C 605,418 650,492 657,552 C 666,618 633,663 587,711 C 614,718 631,729 632,746 L 505,746 C 494,732 502,714 500,693 C 500,673 492,651 479,636 C 426,594 402,546 406,490 C 408,456 424,431 453,417 Z",
    fill: "url(#fit-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hind-rim",
    d: "M 495,405 C 541,395 580,416 609,453 C 640,493 652,522 657,552 C 666,618 633,663 587,711 C 563,721 548,736 544,746 C 550,715 583,687 598,651 C 622,600 623,553 608,509 C 591,457 549,418 495,405 Z",
    fill: "url(#fit-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hind-top-highlight",
    d: "M 453,417 C 480,403 510,403 536,408 C 578,416 610,448 629,488 C 643,518 640,541 618,555 C 604,566 580,570 556,570 C 503,570 454,552 425,526 C 400,504 402,478 413,455 C 421,438 436,425 453,417 Z",
    fill: "url(#fit-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hind-highlight-rim",
    d: "M 495,405 C 541,395 580,416 609,453 C 626,475 638,498 639,517 C 639,533 632,546 618,555 C 615,532 610,513 600,493 C 579,448 540,418 495,405 Z",
    fill: "url(#fit-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hind-lower-shade",
    d: "M 479,636 C 500,656 527,682 540,709 C 548,725 552,736 552,746 L 505,746 C 494,732 502,714 500,693 C 500,673 492,651 479,636 Z",
    fill: "url(#fit-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear-shape",
    d: "M 865,376 C 868,357 878,347 893,345 C 910,347 921,357 927,371 L 912,382 Z",
    fill: "url(#fit-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear-highlight",
    d: "M 874,367 C 879,353 890,348 900,353 C 910,356 915,362 916,368 C 901,360 888,359 874,367 Z",
    fill: "url(#fit-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ear-low",
    d: "M 867,374 C 875,369 890,369 903,376 L 865,380 Z",
    fill: "#009CB9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoulder-main",
    d: "M 718,391 C 761,374 812,370 865,374 C 885,372 908,368 927,370 C 945,373 961,378 979,385 L 982,400 C 1006,410 1028,421 1046,431 C 1037,447 1025,462 1013,472 C 983,476 956,482 931,488 C 894,498 865,516 845,540 C 825,565 808,596 800,631 C 790,670 796,703 809,721 C 767,709 732,687 708,654 C 676,609 655,558 653,509 C 650,459 669,418 718,391 Z",
    fill: "url(#fit-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoulder-outer",
    d: "M 718,391 C 760,374 807,371 856,374 C 810,382 771,399 746,430 C 718,464 715,502 721,548 C 729,615 757,680 809,721 C 767,709 732,687 708,654 C 676,609 655,558 653,509 C 650,459 669,418 718,391 Z",
    fill: "url(#fit-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "head-panel",
    d: "M 856,374 C 884,372 908,368 927,370 C 945,373 961,378 979,385 L 982,400 C 1006,410 1028,421 1046,431 L 1013,472 C 977,468 959,446 928,436 C 900,427 863,437 839,459 C 814,480 801,506 768,517 C 751,523 736,524 720,521 C 718,486 724,457 746,430 C 771,399 810,382 856,374 Z",
    fill: "url(#fit-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "back-light-panel",
    d: "M 718,391 C 760,374 807,371 856,374 C 810,382 771,399 746,430 C 724,457 718,486 720,521 C 701,518 678,507 666,490 C 648,464 655,436 677,416 C 688,405 702,397 718,391 Z",
    fill: "url(#fit-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck-top-highlight",
    d: "M 720,521 C 743,527 772,521 791,507 C 806,496 821,477 840,462 C 853,452 868,446 883,453 C 866,454 851,458 839,462 C 859,444 892,433 919,432 C 952,431 978,442 998,462 L 1013,472 C 968,478 933,487 908,498 C 878,510 858,524 845,540 C 829,561 814,588 794,616 C 790,578 805,529 837,495 C 821,499 803,508 789,518 C 815,486 844,466 883,453 C 853,460 826,474 806,493 C 787,512 759,531 720,521 Z",
    fill: "url(#fit-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chest-light-panel",
    d: "M 883,453 C 860,461 841,475 826,488 C 812,500 801,509 789,518 C 803,508 820,500 837,495 C 805,529 790,578 794,616 C 807,585 826,556 845,540 C 865,516 894,498 931,488 C 955,482 983,476 1013,472 C 980,468 952,453 933,449 C 916,446 900,449 883,453 Z",
    fill: "url(#fit-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chest-deep-edge",
    d: "M 845,540 C 825,565 808,596 800,631 C 790,670 796,703 809,721 C 793,703 787,670 792,640 C 796,600 817,561 845,540 Z",
    fill: "url(#fit-24)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "wordmark",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: " M 306 813 L 299 820 C 295 814 289 811 281 811 C 272 811 267 816 267 823 C 267 830 272 834 282 838 L 293 843 C 305 849 311 856 310 867 C 309 880 298 889 284 889 C 271 889 262 884 256 875 L 263 868 C 269 876 276 880 284 880 C 294 880 301 875 301 867 C 301 860 296 855 286 851 L 274 846 C 263 841 257 834 257 824 C 257 811 267 802 281 802 C 292 802 301 806 306 813 Z M 335 803 H 394 V 813 H 369 V 887 H 359 V 813 H 335 Z M 425 803 H 435 V 855 C 435 871 443 880 457 880 C 471 880 479 871 479 855 V 803 H 489 V 856 C 489 876 477 889 457 889 C 437 889 425 877 425 857 Z M 529 803 H 551 C 578 803 595 820 595 845 C 595 870 578 887 551 887 H 529 Z M 539 813 V 878 H 551 C 572 878 585 865 585 845 C 585 825 572 813 551 813 Z M 623 803 H 635 L 657 835 L 680 803 H 692 L 663 845 V 887 H 652 V 845 Z M 720 803 H 748 C 776 803 792 820 792 845 C 792 870 776 887 748 887 H 720 Z M 743 824 V 867 H 749 C 762 867 769 859 769 845 C 769 831 762 824 749 824 Z M 825 803 H 879 V 824 H 848 V 835 H 873 V 855 H 848 V 867 H 879 V 887 H 825 Z M 911 803 H 933 L 971 850 V 803 H 995 V 887 H 973 L 935 841 V 887 H 911 Z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudydenWhiteWordmarkTransparent);
export default __webpack_public_path__ + "static/media/Studyden_White_Wordmark_Transparent.340a3ab390cfa3d38b70618be35b7290.svg";
export { ForwardRef as ReactComponent };